import { headers, parseJSON } from '../../apiUtils';


export function fetchCoachingSummaryStats(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    const path = `/api/coaching/coaching-summary-stats?fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchCoachedAgentsData(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    const path = `/api/coaching/coached-agents?fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}